var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHourglass01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2056_14251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8L4.82945 5.77454C4.43266 5.44389 4.23427 5.27856 4.09165 5.0759C3.96528 4.89633 3.87143 4.69596 3.81438 4.48393C3.75 4.24462 3.75 3.98637 3.75 3.46988V1.75M7.5 8L10.1706 5.77454C10.5673 5.44389 10.7657 5.27856 10.9084 5.0759C11.0347 4.89633 11.1286 4.69596 11.1856 4.48393C11.25 4.24462 11.25 3.98637 11.25 3.46988V1.75M7.5 8L4.82945 10.2255C4.43266 10.5561 4.23427 10.7214 4.09165 10.9241C3.96528 11.1037 3.87143 11.304 3.81438 11.5161C3.75 11.7554 3.75 12.0136 3.75 12.5301V14.25M7.5 8L10.1706 10.2255C10.5673 10.5561 10.7657 10.7214 10.9084 10.9241C11.0347 11.1037 11.1286 11.304 11.1856 11.5161C11.25 11.7554 11.25 12.0136 11.25 12.5301V14.25M2.5 1.75H12.5M2.5 14.25H12.5",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2056_14251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass01);
export default __webpack_public_path__ + "static/media/hourglass-01.384ff0050568a0c8a7a4e9d87fb19bdc.svg";
export { ForwardRef as ReactComponent };